import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"


const RangeSlider = React.forwardRef<
    React.ComponentRef<typeof SliderPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
    <SliderPrimitive.Root
        className={cn(
            "relative flex w-full cursor-pointer touch-none select-none items-center data-[disabled]:cursor-not-allowed",
            className
        )}
        ref={ref}
        {...props}
    >
        <SliderPrimitive.Track className="relative h-2.5 w-full grow overflow-hidden rounded-full bg-primary/20">
            <SliderPrimitive.Range className="absolute h-full bg-primary" />
        </SliderPrimitive.Track>
        {(props.value ?? props.defaultValue)?.map((value, index) => (
            <SliderPrimitive.Thumb
                className="inline-flex items-center justify-center h-6 w-6 text-xs bg-background rounded-full border-2 border-primary/50 shadow-sm transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
                key={index}
            >
                    {value}
            </SliderPrimitive.Thumb>
        ))}
    </SliderPrimitive.Root>
));


export { RangeSlider }
